<template>
  <action-dispatcher
    action="courses/getResource"
    :parameters="$route.params.id"
    class="view-live container text-light py-5"
  >
    <router-link class="small text-secondary" :to="{ name: 'lives' }">
      <i class="fas fa-chevron-left" /> Lives
    </router-link>
    <div class="row justify-content-center">
      <div
        :class="{
          'col-lg-8': youtubeId,
          'col-lg-10': !youtubeId
        }"
      >
        <div class="d-flex justify-content-center">
          <div class="w-100">
            <video-player class="my-4" :lesson="resource" />
          </div>
        </div>
        <h5>{{ resource.name }}</h5>
        <p>
          {{ resource.description }}
        </p>
      </div>
      <div v-if="youtubeId" class="col-lg-4">
        <div class="embed-responsive chat">
          <iframe
            class="embed-responsive-item"
            :src="chatUrl"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import get from "lodash/get";
import VideoPlayer from "@/components/lesson/VideoPlayer";
import { youtubeParser } from "@/functions/helpers";

export default {
  components: { VideoPlayer },
  computed: {
    ...mapState("courses", ["resource"]),
    youtubeId() {
      const youtubeUrl = get(this.resource, "youtube_url");

      if (!youtubeUrl) return null;

      return youtubeParser(youtubeUrl);
    },
    chatUrl() {
      return `https://www.youtube.com/live_chat?v=${this.youtubeId}&embed_domain=${document.location.hostname}`;
    }
  }
};
</script>
